import React from "react";
import Generic from './Generic'
const Package4 = props => {

    return (<Generic title={"מומלץ"} price={"1.5₪ לרשומה"} include={[
        true, // 1
        true, // 2
        true, // 3
        true, // 4
        true, // 5
        true, // 6
        true, // 7
        true, // 8
        true, // 9
        true, // 10
        true, // 11
        true, // 12
        true, // 13
        true, // 14
        true, // 15
        true, // 16
        false, // 17
        false, // 18
    ]} />)
}

export default Package4;